<template>
  <td>
    <template v-for="task in value">
       <v-chip
        :class="classes(task)"
        :key="task.id + '-chip'"
        style="height: auto"
      >
        {{task.shortName}}
        <span v-if="showDueAt">&nbsp;({{ task.intervalTypeUnits !== 'days' ? `due at ${task.dueAt} ${ task.intervalTypeUnits })` : `time based)`}}</span>
        <div v-if="documentsEnabled" class="document-icon-container">
          <div v-if="task.documents && task.documents.length > 0" v-for="document in task.documents">
            <v-btn x-small text :href="document.documentUrl" target="_blank">
              <v-icon small>mdi-clipboard-check-outline</v-icon>
            </v-btn>
          </div>
          <v-icon v-if="task.documentationRequired && (!task.documents || task.documents.length === 0)" style="color: red" small>mdi-clipboard-alert-outline</v-icon>
        </div>
      </v-chip>
      <v-chip
        class="mr-2"
        :key="task.id + '-tolerance'"
        v-if="showCompletedAtTolerance && (task.completedAtTolerance || task.completedAtTolerance === 0)"
        label
        small
        :color="task.completedAtTolerance > 0 ? 'red' : null"
        :dark="task.completedAtTolerance > 0 ? true : null"
      >
        {{task.completedAtTolerance > 0 ? `+${task.completedAtTolerance}` : task.completedAtTolerance }} {{ task.intervalTypeUnits }}
      </v-chip>
        <v-chip
            class="mr-2"
            :key="task.id + '-tolerance'"
            v-if="showDueAtTolerance && (task.originalDueAtTolerance || task.originalDueAtTolerance === 0)"
            label
            small
            :color="task.originalDueAtTolerance > 0 ? 'red' : null"
            :dark="task.originalDueAtTolerance > 0 ? true : null"
        >
            {{task.originalDueAtTolerance > 0 ? `+${task.originalDueAtTolerance}` : task.originalDueAtTolerance }} {{ task.intervalTypeUnits }}
        </v-chip>
    </template>
  </td>
</template>
<script>

export default {
  props: {
    value: { required: true },
    showCompletedAtTolerance: { type: Boolean, default: false },
    showDueAtTolerance: { type: Boolean, default: false },
    showDueAt: { type: Boolean, default: false },
    documentsEnabled: { type: Boolean, default: false }
  },
  methods: {
    classes(task) {
      return {
        'mr-2': true,
        completed: task.completed,
        sweptForward: !task.completed && task.sweptForwardByScheduler
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.document-icon-container {
  padding-left: 8px;
}
</style>
